// ── Enums ──────────────────────────────────────────────────────────────────────
/** ABC velocity classification tier */
export var ABCClass;
(function (ABCClass) {
    ABCClass["A"] = "A";
    ABCClass["B"] = "B";
    ABCClass["C"] = "C";
})(ABCClass || (ABCClass = {}));
/** XYZ demand variability classification tier */
export var XYZClass;
(function (XYZClass) {
    XYZClass["X"] = "X";
    XYZClass["Y"] = "Y";
    XYZClass["Z"] = "Z";
})(XYZClass || (XYZClass = {}));
/** Velocity metric used for ABC classification */
export var VelocityMetric;
(function (VelocityMetric) {
    VelocityMetric["PickFrequency"] = "pick_frequency";
    VelocityMetric["UnitsMoved"] = "units_moved";
    VelocityMetric["RevenueContribution"] = "revenue";
    VelocityMetric["OrderLines"] = "order_lines";
})(VelocityMetric || (VelocityMetric = {}));
/** Period granularity for demand aggregation */
export var PeriodGranularity;
(function (PeriodGranularity) {
    PeriodGranularity["Daily"] = "daily";
    PeriodGranularity["Weekly"] = "weekly";
    PeriodGranularity["Monthly"] = "monthly";
})(PeriodGranularity || (PeriodGranularity = {}));
/** Warehouse zone classification */
export var ZoneType;
(function (ZoneType) {
    ZoneType["GoldenZone"] = "golden_zone";
    ZoneType["ForwardPick"] = "forward_pick";
    ZoneType["Reserve"] = "reserve";
    ZoneType["Bulk"] = "bulk";
    ZoneType["ColdStorage"] = "cold_storage";
    ZoneType["Hazmat"] = "hazmat";
    ZoneType["Oversize"] = "oversize";
})(ZoneType || (ZoneType = {}));
/** Ergonomic pick height classification */
export var PickHeight;
(function (PickHeight) {
    PickHeight["Floor"] = "floor";
    PickHeight["Waist"] = "waist";
    PickHeight["Shoulder"] = "shoulder";
    PickHeight["Overhead"] = "overhead";
})(PickHeight || (PickHeight = {}));
/** Pick method for a zone or location */
export var PickMethod;
(function (PickMethod) {
    PickMethod["EachPick"] = "each";
    PickMethod["CasePick"] = "case";
    PickMethod["PalletPick"] = "pallet";
})(PickMethod || (PickMethod = {}));
/** SKU lifecycle status */
export var LifecycleStatus;
(function (LifecycleStatus) {
    LifecycleStatus["Active"] = "active";
    LifecycleStatus["PhaseOut"] = "phase_out";
    LifecycleStatus["NewItem"] = "new_item";
    LifecycleStatus["Discontinued"] = "discontinued";
})(LifecycleStatus || (LifecycleStatus = {}));
//# sourceMappingURL=index.js.map